module.exports = __webpack_public_path__ + "static/media/maze.828887ea.svg";